import React, { Component } from 'react';
import JurisLogo from './JurisLogo';
import Arrow from '../assets/Arrow.gif';
import smoothScroll from 'smoothscroll';


class JurisFooter extends Component {

    handleClick(e) {
        e.preventDefault();
        smoothScroll(document.querySelector("#header"));
    }

    render(){
        return (
            <footer className="juris-footer row dark-bg text-center">

                <div className="arrow">
                    <a href="#" onClick={this.handleClick}>
                        <img src={Arrow} role="presentation" />
                    </a>
                </div>

                <div className="col-xs-12">
                    <div className="logo-container"> 
                        <JurisLogo />
                    </div>
                </div>

                <div className="col-xs-12">
                    <div className="legal">
                        <span> © Juris Montréal 2016 </span>
                    </div>
                </div>

            </footer>
        )
    }

}


export default JurisFooter;


/** WEBPACK FOOTER **
 ** ./src/components/JurisFooter.jsx
 **/